import { useContext } from "react";
import { Button } from "../Button";
import Modal, { ModalContext } from "./Modal";
import { Form, Formik } from "formik";
import { underskrivValidationSchema } from "../../util/validationSchema/common";
import InputField from "../form/InputField";
import IsRequired from "../form/IsRequired";
import InputErrorMessage from "../error/InputErrorMessage";

const UnderskrivModal = ({
  isFinal,
  onSubmitHandler,
  numEmails,
}: {
  isFinal: boolean;
  onSubmitHandler: (values: {
    email: string;
    email2: string | undefined;
  }) => void;
  numEmails?: 1 | 2;
}) => {
  const { setModalOpen } = useContext(ModalContext);

  const numberOfEmails = numEmails || 1;

  return (
    <Modal dialog small>
      <Formik
        validationSchema={underskrivValidationSchema}
        initialValues={{ email: "", email2: "" }}
        onSubmit={(values) => onSubmitHandler(values)}
      >
        {(props) => {
          const { handleSubmit, errors, dirty, values } = props;
          return (
            <Form onSubmit={handleSubmit}>
              <div>
                <h2 className="display-4 fw-semibold mb-2">
                  Kvittering på e-mail
                  <IsRequired />
                </h2>
                <p>
                  I tilfælde af spørgsmål kan Advokatsamfundet kontakte mig på
                  e-mail:
                  <br />
                </p>
                <div className="mt-2 mb-4">
                  <InputField
                    config={{
                      component: "textinput",
                      id: "email",
                      initialValue: "",
                      placeholder: "E-mailadresse",
                    }}
                    formik={props}
                  />
                  <InputErrorMessage value={errors.email} />
                </div>

                <p className="">
                  Advokatsamfundet fremsender en kvittering for din indberetning
                  til ovenstående e-mailadresse.
                </p>

                {numberOfEmails === 2 && (
                  <>
                    <p>
                      Du kan indtaste en ekstra mailadresse, hvis
                      mailkvitteringen også skal sendes til f.eks. din
                      HR-afdeling
                    </p>
                    <div className="mt-2 mb-4">
                      <InputField
                        config={{
                          component: "textinput",
                          id: "email2",
                          initialValue: "",
                          placeholder: "Ekstra e-mailadresse",
                        }}
                        formik={props}
                      />
                      <InputErrorMessage value={errors.email2} />
                    </div>
                  </>
                )}

                <div className="d-flex justify-content-between">
                  <Button
                    className="btn-outline-primary-subtle"
                    type="button"
                    onClick={() => setModalOpen(false)}
                  >
                    Annuller
                  </Button>
                  <Button
                    color="primary"
                    type="submit"
                    disabled={
                      (!dirty || !!errors.email || !!errors.email2) &&
                      (values.email !== "" || values.email2 !== "")
                    }
                  >
                    Godkend{isFinal ? " og indsend" : ""}
                  </Button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default UnderskrivModal;
